import { useState } from "react";
import { useBulkApproveAgentActions } from "./query";

export const useBulkApprove = (businessId: string | null) => {
  const bulkApprove = useBulkApproveAgentActions(businessId);
  const [approvingIds, setApprovingIds] = useState<ReadonlySet<string>>(
    () => new Set(),
  );
  const approve = (ids: string[]) => {
    setApprovingIds((current) => new Set([...current, ...ids]));
    return bulkApprove.mutateAsync(ids).finally(() =>
      setApprovingIds((current) => {
        const next = new Set(current);
        ids.forEach((id) => next.delete(id));
        return next;
      }),
    );
  };
  return { approvingIds, approve };
};
